import React, { useState } from 'react';
import {
  AquistaButton,
  AquistaButtonsContainer,
  CompanyInfoElements,
  CompanyInformationContainer,
  LeftCol,
  LogoContainer,
  LogoPriceContainer,
  Price,
  PriceContainer,
  QuoteInformationContainer,
  QuoteInformationItem,
  RightCol,
  RiskCardStyles,
  SavedButton,
} from '../ResultPageComponents/v2/RiskCard.styles';
import { BACKEND_BASE_URL } from '../../../../config';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';
import TutelaLegaleInfoModal from '../Modal/TutelaLegaleInfoModal';

function AragCard({
  quotation, selectQuotation, requestInfo, type,
}) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {showModal && (
        <TutelaLegaleInfoModal
          quotation={quotation}
          setShowModal={setShowModal}
        />
      )}
      <RiskCardStyles className={quotation.is_aquista === 1 ? 'selected' : ''}>
        <LeftCol>
          <LogoPriceContainer>
            <LogoContainer>
              <img
                src={BACKEND_BASE_URL + quotation.company.logo}
                alt={`${quotation.company.name} Logo`}
              />
            </LogoContainer>
            <PriceContainer>
              <Price>
                <h5>Prezzo annuo:</h5>
                <h2>
                  &euro;
                  {Number(quotation.amount).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                </h2>
              </Price>
            </PriceContainer>
          </LogoPriceContainer>
          {quotation.information && (
            <CompanyInformationContainer>
              <CompanyInfoElements onClick={() => setShowModal(!showModal)}>
                <img src={infoIcon} alt="" />
                <p>Maggiori informazioni</p>
              </CompanyInfoElements>
            </CompanyInformationContainer>
          )}

          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Compagnia:</h6>
              <p>{quotation.company.name}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Prodotto:</h6>
              <p>{quotation.sub_product ? 'Tutela Legale' : type.name}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Frequenza pagamento:</h6>
              <p>Annuo</p>
            </QuoteInformationItem>
          </QuoteInformationContainer>
          <QuoteInformationContainer>
            {quotation.risk_massimale != 0 && (
              <QuoteInformationItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(quotation.risk_massimale).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                  &euro;
                </p>
              </QuoteInformationItem>
            )}
            <QuoteInformationItem>
              <h6>Nome Prodotto:</h6>
              <p>{quotation.product_name}</p>
            </QuoteInformationItem>
          </QuoteInformationContainer>
        </LeftCol>
        <RightCol>
          <AquistaButtonsContainer>
            {requestInfo.tutela_legale_quote_id !== quotation.id ? (
              <AquistaButton
                onClick={() => selectQuotation(quotation.id)}
                className="purchase-quote-nine-step"
              >
                Seleziona
              </AquistaButton>
            ) : (
              requestInfo.tutela_legale_quote_id === quotation.id && (
                <SavedButton>Aggiunto</SavedButton>
              )
            )}
          </AquistaButtonsContainer>
        </RightCol>
      </RiskCardStyles>
    </>
  );
}

export default AragCard;
